import styled from "styled-components";
import { MainContainer as MainContainerOriginal } from "containers/CurrentNotification/CurrentNotificationStyled";

export { Paragraph } from "globalStyles/Containers";

export const CardContainer = styled.section`
  display: block;
  margin: 0;
  position: relative;

  ${props =>
    !props.isCurrent
      ? `

    &:first-of-type:before {
      width: 16px;
      height: 16px;
      left: -12px;
      background: radial-gradient(circle at center, ${
        props.theme.loadingColor
      } 4px, transparent 4px);
    }

    padding-left: 15px;
    border-left: 2px solid ${props.theme.lineColor}

    &:before {
      content: "";
      position: absolute;
      z-index: 1;

      ${
        props.isPrincipal
          ? `
              top: 18px;
              left: -9px;
              font-size: 20px;
              display: inline-block;
              width: 9px;
              height: 9px;
              box-sizing: content-box;
              border: 4px solid ${props.theme.loadingColor};
              border-radius: 50px;
              background: ${props.theme.backgroundColor};
          `
          : `
              top:65px;
              left: -11px;
              height: 100%;
              width: 20px;
              background-image: radial-gradient(circle at center, ${props.theme.loadingColor} 4px, transparent 4px);
              background-size: 10px 10px;
              background-position: top center, bottom center;
              background-repeat: no-repeat;
            `
      }
    }

    &:after {
      content: '';
      position: absolute;
      width: 2px;
      left: -2px;
      background: ${props.theme.backgroundColor};
    }

    &:last-of-type:after {
      height: 100%;
      top: 75px;
    }

    &:first-of-type:after {
      height: ${props.isPrincipal ? "30px" : "65px"};
      top: 0;
    }
  `
      : `
       margin-bottom: 10px;
       `}
`;

export { CardBox } from "../../globalStyles/CardDetails";

export const MainContainer = styled(MainContainerOriginal)`
  padding-top: 0;
`;

export const MainContainerFollowUp = styled(MainContainer)`
  padding-top: 24px;
`;

export const Buttons = styled.div`
  padding-top: 24px;
`;

export const PicturesContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  display: flex;
`;

export const SplitPanel = styled.div`
  display: flex;
  margin: 0 8px;
  flex-direction: column;
  flex-grow: 1;
`;
